module.exports = __webpack_public_path__ + "img/austria-blood-diseases-male.477d034e.png";